import React from "react";
import "./styles.css";

const Brand = (props: any) => {
    return props.size === 0 ? <div className="brand"></div> : <div className="brand2"></div>;
};

export default Brand;
